// plugins/activity.js
//import { checkAuth } from "./auth"; // adjust if you have a way to get current user
 import http from "@/http";
export function recordUserActivity(activity) {
    // Pull whatever user identity you have available — e.g. from a token/store
    const userActivityModels = {
        userActivity: activity,
        userName: getCurrentUser(),
    };

    http.post(`Admin/RecUAS`, userActivityModels)
        .then(response => {
         return    response.data;   // response.data available here if you need to do anything with it
        })
        .catch(() => {
            // fail silently, or add logging/retry logic as needed
        });

    // send it wherever it needs to go
    // e.g. axios.post('/api/user-activity', payload);
 //   console.log('User activity:', payload);
}

// function getCurrentUser() {
//     // e.g. pull from localStorage token, Vuex store, etc.
//     return localStorage.getItem('userName') || 'unknown';
// }
function getCurrentUser() {
    return getCookie('HMIS_USERNAME') || 'unknown';
}

function getCookie(name) {
    const match = document.cookie.match(
        new RegExp('(^| )' + name + '=([^;]+)')
    );
    return match ? decodeURIComponent(match[2]) : null;
}